var $ = jQuery.noConflict();  
var locale = my_script_vars.locale;  
var mustFillError = my_script_vars.mustFillError;  

$(document).ready(function () {
     
    $('.woocommerce-shipping-fields input, .woocommerce-shipping-fields select').change(function(e) {
        if ( $('.woocommerce-billing-fields input[name="same-addresses"]').is(':checked') ) {
            let name = $(this).attr('name').replace('shipping', 'billing');
            let value = $(this).val();

            $('.woocommerce-billing-fields [name="'+ name +'"]').val(value);
        }
    });

    $('.woocommerce-billing-fields input[name="same-addresses"]').change(function(e) {
        if ( $(this).is(':checked') ) {
            $('.woocommerce-billing-fields__field-wrapper').removeClass('visible');

            $('.woocommerce-shipping-fields input, .woocommerce-shipping-fields select').each(function(i, item) {
                let name = $(this).attr('name').replace('shipping', 'billing');
                let value = $(this).val();

                $('.woocommerce-billing-fields [name="'+ name +'"]').val(value);
            });
        }
        else {
            $('.woocommerce-billing-fields__field-wrapper').addClass('visible');

            $('.woocommerce-billing-fields input, .woocommerce-billing-fields select').each(function(i, item) {
                if ( $(this).attr('name') != 'billing_phone' && $(this).attr('name') != 'billing_email' && $(this).attr('name') != 'billing_country' ) {
                    $(this).val('');
                }
            });
        }
    });

    // steps
    $('.js-next-step').click(function(e) {
        e.preventDefault();

        $('.validate-required input, .validate-required select').trigger('validate');

        if ( $('.woocommerce-checkout__step--1 .woocommerce-invalid').length ) {
            let $errors = [];

            $('.woocommerce-NoticeGroup.woocommerce-NoticeGroup-checkout').remove();
            $('form.woocommerce-checkout').prepend('<div class="woocommerce-NoticeGroup woocommerce-NoticeGroup-checkout"><ul class="woocommerce-error" role="alert"></ul></div>');

            $('.woocommerce-checkout__step--1 .woocommerce-invalid').each(function(i, item) {
                let $label = $(this).find('label').text();

                if ( $.inArray($label, $errors) === -1 ) {
                    $('.woocommerce-NoticeGroup.woocommerce-NoticeGroup-checkout ul').append('<li><strong>' + $label + '</strong>' + ' ' + mustFillError + '</li>');
                }

                $errors.push($label);
            });
        }
        // else if ( !$('input[name="billing_phone"]').match ('^\d{4}-\d{6}$|^\d{6,}$') || !$('input[name="shipping_phone"]').match ('^\d{4}-\d{6}$|^\d{6,}$') ) {
        //     if ( !$('.woocommerce-NoticeGroup.woocommerce-NoticeGroup-checkout').length ) {
        //         $('form.woocommerce-checkout').prepend('<div class="woocommerce-NoticeGroup woocommerce-NoticeGroup-checkout"><ul class="woocommerce-error" role="alert"></ul></div>');
        //     }
        //
        //     $('.woocommerce-NoticeGroup.woocommerce-NoticeGroup-checkout ul').append('<li><strong>' + $(this).find('label').text() + '</strong> har ogiltigt format.</li>');
        // }
        else {
            $('.woocommerce-checkout__step--1').removeClass('js-active');

            $('.woocommerce-checkout__step--2').addClass('js-active');
            $('.woocommerce-NoticeGroup.woocommerce-NoticeGroup-checkout').remove();
        }
    });


    // terms
    $('body').on('click', '.woocommerce-terms-and-conditions-link', function (e) {
        e.preventDefault();
        $('.woocommerce-terms-and-conditions').addClass('js-open');
        $('.woocommerce-terms-and-conditions .block-post-container').append('<span class="js-close"></span>');
    });

    $('body').on('click', '.woocommerce-terms-and-conditions .block-post-container .js-close', function (e) {
        e.preventDefault();
        $('.woocommerce-terms-and-conditions').removeClass('js-open');
        $('.woocommerce-terms-and-conditions .block-post-container .js-close').remove();
    });


 // Prevent immediate form submit on quantity input changes /sparat-material/
 // We want debounce the timer to prevent spam requests when changing input value
  $('.cart-content__form').on('submit', function(e) {
    if ($(this).data('prevent-submit')) {
      e.preventDefault();
    }
  });

  let debounceTimer;

  $('.cart-content__form').on('input', 'input.qty', function() {
    $('.cart-content__form').data('prevent-submit', true);

    clearTimeout(debounceTimer);

    // Set new timer to enable submit and trigger update_cart after 2 seconds of no input
    debounceTimer = setTimeout(function() {
      $('.cart-content__form').data('prevent-submit', false);

      $('.cart-content__form button[name="update_cart"]').trigger('click');
    }, 2000);
  });

});
